import { ROLE_REPORTING_ADMIN } from '~/consts/roles';

import isProd from './isProd';

type LensUser = { roles?: Array<string>; email?: string | null };

export function canAccessLeLens(user: LensUser | null | undefined, pilotAllowed = false): boolean {
  if (!user) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  if (user.roles?.includes(ROLE_REPORTING_ADMIN)) {
    return true;
  }

  return Boolean(user.email && pilotAllowed);
}

